import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog, MatSnackBar } from '@angular/material';
import { FormGroup } from '@angular/forms';
import { SharedModalInfoComponent } from '../../../../../shared/modal-info/modal-info.component';
import { Util } from '../../../../../utils/util';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixPaymentFavoredView } from '../../../models/payment-favored-view.model';
import { PixPaymentKeyService } from '../../payment-key.service';
import { Auth } from '../../../../../autentication/Auth';
import { AutenticationService } from '../../../../../autentication/autentication.service';
import { PixTransferRequest } from '../../../models/transfer-request.model';
import { EventTypes } from '../../../../../shared/EventTypes';
import { AppEventDispatcher } from '../../../../../utils/AppEventDispatcher';
import { PixKey } from '../../../models/key.model';
import * as moment from 'moment';
import { PixReceipt } from '../../../models/receipt.model';
import { PixKeysService } from '../../../keys/keys.service';
import { PixPaymentFavored, PixPaymentFavoredAccount } from '../../../models/payment-favored.model';
import { PixTransferReturn, PixTransferReturnSituacaoTransferencia, PixTransferReturnSucesso } from '../../../models/transfer-return.model';
import { PixPaymentKeyFavoredCreateDetailComponent } from '../details/details.component';
import { TipoIniciacao } from '../../../models/tipo-iniciacao.enum';
import { PixAntiFraudModalComponent } from '../../modal/anti-fraud/anti-fraud.component';
import { ModalAntifraudWarningComponent } from '../../../../../shared/modal-antifraud-warning/modal-antifraud-warning.component';

@Component({
	selector: 'app-pix-payment-key-favored-create-assignature',
	templateUrl: './assignature.component.html',
	styleUrls: ['./assignature.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixPaymentKeyFavoredCreateAssignatureComponent implements OnInit {

	public submited = false;
	public form: FormGroup;
	public selectedPixPaymentFavoredView: PixPaymentFavoredView;
	public guid = '';
	private scheduledPayment = false;

	nameTransfer: string;
	valueTransfer: number;
	dateTransfer: string;
	showAntifraudScreen: boolean = false;
	isScheduled: boolean;

	constructor(
		private autenticationService: AutenticationService,
		private pixPaymentKeyService: PixPaymentKeyService,
		private pixKeysService: PixKeysService,
		private router: Router,
		public dialog: MatDialog,
		private snackBar: MatSnackBar,
	) { }

	ngOnInit() {
		this.selectedPixPaymentFavoredView = this.pixPaymentKeyService.getSelectedPixPaymentFavoredView();
		this.guid = Util.generateGUID();
		this.scheduledPayment = this.getDateToTransfer(this.selectedPixPaymentFavoredView.dataTransferir) !== null;

		if (this.invalidParams()) {
			this.goBack();
		}

		this.isScheduled = (this.selectedPixPaymentFavoredView.dataTransferir && moment(this.selectedPixPaymentFavoredView.dataTransferir) !== moment());
	}

	invalidParams(): boolean {
		return this.selectedPixPaymentFavoredView === undefined ||
			this.selectedPixPaymentFavoredView.tipoChave === undefined ||
			this.selectedPixPaymentFavoredView.dataTransferir === undefined ||
			this.selectedPixPaymentFavoredView.valorTransferir === undefined ||
			(this.selectedPixPaymentFavoredView.tipoChave !== PixKeyType.MANUAL && this.selectedPixPaymentFavoredView.codigoFimAFim === undefined) ||
			(this.selectedPixPaymentFavoredView.tipoChave !== PixKeyType.MANUAL && this.selectedPixPaymentFavoredView.codigo === undefined) ||
			(this.selectedPixPaymentFavoredView.tipoChave === PixKeyType.MANUAL && this.selectedPixPaymentFavoredView.numeroAgencia === undefined || this.selectedPixPaymentFavoredView.numeroConta === undefined);
	}

	submit(message: boolean) {
		this.submited = message;

		if (this.submited && this.form.valid) {
			this.addAuthToken();
			this.sendAssignature();
		}
	}

	addAuthToken() {
		if (this.form.value.token) {
			Auth.passToken = this.form.value.token;
		}
	}

	addAuthSignature() {
		if (this.form.value.eletronicSignature) {
			Auth.assinaturaEletronica = this.form.value.eletronicSignature;
		}
	}

	sendAssignature() {
		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {
			if (data.Sucesso) {
				this.addAuthSignature();
				this.sendRequest();
			}
		}, error => {
			this.handleError(error);
		});
	}

	sendRequest() {
		const model = this.generatePixTransferModel();

		this.pixPaymentKeyService.postTransfer(model).subscribe(data => {
			if (data.Sucesso) {
				this.pixPaymentKeyService.setSelectedPixPaymentFavoredView(null);
				const result = Util.keysToCamel(data.Retorno) as PixTransferReturn;
				this.processResult(result);
			}
		}, error => {
			this.handleError(error);
		});
	}

	processResult(result: PixTransferReturn) {
		switch (result.situacaoTransferencia) {
			case PixTransferReturnSituacaoTransferencia.AGUARDANDO_AUTORIZACAO:
				this.generateReceiptScheduled(false, this.isScheduled);
				this.dialog.open(PixPaymentKeyFavoredCreateDetailComponent, { width: '400px', data: {
					situacaoTransferencia: result.situacaoTransferencia,
					nome: this.selectedPixPaymentFavoredView.nome,
					valor: this.selectedPixPaymentFavoredView.valorTransferir,
					dataContabil: this.selectedPixPaymentFavoredView.dataTransferir,
					complemento: this.selectedPixPaymentFavoredView.descricaoTransferir,
					codigoTransacao: result.sucesso !== undefined ? result.sucesso.codigoTransacao : null,
					agendado: this.scheduledPayment
				}}).afterClosed().subscribe(result => {
					if (result === undefined) {
						this.router.navigate(['pix']);
					}
				});
				break;
			case PixTransferReturnSituacaoTransferencia.AUTORIZADA_AGUARDANDO_EFETIVACAO:
				this.generateReceiptScheduled(true, true);
				this.dialog.open(PixPaymentKeyFavoredCreateDetailComponent, { width: '400px', data: {
					situacaoTransferencia: result.situacaoTransferencia,
					nome: this.selectedPixPaymentFavoredView.nome,
					valor: this.selectedPixPaymentFavoredView.valorTransferir,
					dataContabil: this.selectedPixPaymentFavoredView.dataTransferir,
					complemento: this.selectedPixPaymentFavoredView.descricaoTransferir,
					codigoTransacao: result.sucesso !== undefined ? result.sucesso.codigoTransacao : null,
					agendado: this.scheduledPayment
				}}).afterClosed().subscribe(result => {
					if (result === undefined) {
						this.router.navigate(['pix']);
					}
				});
				break;
			case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_REALIZADA:
				this.generateReceipt(result.sucesso);
				this.router.navigate(['pix/pagamento/favorecido/adicionar/comprovante']);
				break;
			case PixTransferReturnSituacaoTransferencia.AGUARDANDO_CONFIRMACAO_IF_DESTINO:
				this.openModal(
					'Estamos processando essa transação',
					'Essa transação esta demorando um pouco mais que o normal',
					'Assim que ela for concluída, ele estará disponível no Extrato. Caso contrário, consulte o item em Transações não realizadas no menu Transações',
					'Entendi');
				break;
				case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_REPROVADA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.TRANSFERENCIA_EXPIRADA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.ERRO_TRANSFERENCIA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.REJEITADA_IF_DESTINO:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.CANCELADA_TESOURARIA:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.CANCELADA_CLIENTE:
					this.openModal('Transação não concluída', '', result.mensagem);
					break;
				case PixTransferReturnSituacaoTransferencia.AGUARDANDO_ANALISE_ANTIFRAUDE:
					this.setDataAntifraudScreen();
					break;
				case PixTransferReturnSituacaoTransferencia.CANCELADA_SUSPEITA_FRAUDE:
					this.router.navigate([""], { skipLocationChange: true });
					this.dialog.open(ModalAntifraudWarningComponent, {
						data: []
					});
					break;

			default:
				break;
		}
	}

	setDataAntifraudScreen(): void {
		this.nameTransfer = Util.camelCaseText(this.selectedPixPaymentFavoredView.nome);
		this.valueTransfer = this.selectedPixPaymentFavoredView.valorTransferir;
		this.dateTransfer = this.selectedPixPaymentFavoredView.dataTransferir.toLocaleDateString();
		this.showAntifraudScreen = true;
	}

	saveFavored() {
		if (this.selectedPixPaymentFavoredView.toSave) {
			this.pixKeysService.postFavored(this.convertToPixPaymentFavored()).subscribe(result => {
				if (result.Sucesso) {
					this.snackBar.open('Favorecido salvo com sucesso', 'Ok', { duration: 2000, });
				}
			});
		}
	}

	generateReceipt(ret: PixTransferReturnSucesso) {
		const model = new PixReceipt();

		model.authorized = true;
		model.numeroConta = ret.transacaoPix.numeroConta;
		model.tipoConta = ret.transacaoPix.tipoConta;
		model.agencia = ret.transacaoPix.agencia;
		model.complemento = ret.transacaoPix.complemento;
		model.documento = Util.removeNonNumerics(ret.transacaoPix.documento);
		model.codigoFimAFim = ret.transacaoPix.codigoFimAFim;
		model.iSPBCodigo = ret.transacaoPix.codigoISPB;
		model.iSPBNome = ret.transacaoPix.nomeISPB;
		model.nome = ret.transacaoPix.nome;
		model.codigoTransacao = ret.codigoTransacao;
		model.dataTransacao = ret.dataTransacao;
		model.dataContabil = ret.dataContabil;
		model.valor = ret.valor;
		model.codigoChave = this.selectedPixPaymentFavoredView.codigo;
		model.tipoChave = this.selectedPixPaymentFavoredView.tipoChave;
		model.autenticacao = ret.transacaoPix.autenticacao;

		this.pixPaymentKeyService.setSelectedPixReceipt(model);
	}

	generateReceiptScheduled(authorized: boolean, scheduled: boolean) {
		const model = new PixReceipt();

		model.agendado = scheduled;
		model.authorized = authorized;
		model.nome = this.selectedPixPaymentFavoredView.nome;
		model.dataTransacao = this.selectedPixPaymentFavoredView.dataTransferir;
		model.dataContabil = this.selectedPixPaymentFavoredView.dataTransferir;
		model.valor = this.selectedPixPaymentFavoredView.valorTransferir;
		model.complemento = this.selectedPixPaymentFavoredView.descricaoTransferir;
		model.codigoChave = this.selectedPixPaymentFavoredView.codigo;
		model.tipoChave = this.selectedPixPaymentFavoredView.tipoChave;
		model.iSPBNome = this.selectedPixPaymentFavoredView.iSPBNome;
		model.agencia = this.selectedPixPaymentFavoredView.numeroAgencia;
		model.numeroConta = this.selectedPixPaymentFavoredView.numeroConta;
		model.tipoConta = this.selectedPixPaymentFavoredView.tipoConta;
		model.documento = Util.removeNonNumerics(this.selectedPixPaymentFavoredView.documento);

		this.pixPaymentKeyService.setSelectedPixReceipt(model);
	}

	generatePixTransferModel(): PixTransferRequest {
		const model = new PixTransferRequest();
		model.descricao = this.selectedPixPaymentFavoredView.sequencial ? this.selectedPixPaymentFavoredView.sequencial : '';
		model.agencia = this.selectedPixPaymentFavoredView.numeroAgencia;
		model.numeroConta = this.selectedPixPaymentFavoredView.numeroConta ? this.selectedPixPaymentFavoredView.numeroConta : null;
		model.tipoConta = this.selectedPixPaymentFavoredView.tipoConta;
		model.documento = Util.removeNonNumerics(this.selectedPixPaymentFavoredView.documento);
		model.iSPBCodigo = this.selectedPixPaymentFavoredView.iSPBCodigo ? this.selectedPixPaymentFavoredView.iSPBCodigo : null;
		model.nome = this.selectedPixPaymentFavoredView.nome;
		model.codigoRequisicao = this.guid;
		model.codigoChave = new PixKey();
		model.codigoChave.codigo = this.selectedPixPaymentFavoredView.codigo;
		model.codigoChave.tipoChave = this.selectedPixPaymentFavoredView.tipoChave;
		model.codigoFimAFim = this.selectedPixPaymentFavoredView.codigoFimAFim;
		model.tipoCanalIniciacao = 'APLICATIVO';
		model.tipoIniciacao = this.getTipoIniciacao();
		model.sequencialFavorecido = this.selectedPixPaymentFavoredView.sequencial;
		model.tipoIniciacaoTransferencia = this.selectedPixPaymentFavoredView.tipoIniciacaoTransacao;
		model.numeroOrigem = null;
		model.codigoTransacaoQrCode = this.getCodigoTransacaoQrCode();
		model.dataAgendamento = this.getDateToTransfer(this.selectedPixPaymentFavoredView.dataTransferir);
		model.descricao = this.selectedPixPaymentFavoredView.descricaoTransferir;
		model.valor = this.selectedPixPaymentFavoredView.valorTransferir;
		model.salvarFavorecido = this.selectedPixPaymentFavoredView.salvarFavorecido;

		return model;
	}

	getCodigoTransacaoQrCode() {
		return this.selectedPixPaymentFavoredView.codigoTransacaoQrCode === '***' ? null : this.selectedPixPaymentFavoredView.codigoTransacaoQrCode;
	}

	getTipoIniciacao(): TipoIniciacao {
		if (this.selectedPixPaymentFavoredView.tipoQrCode === 'ESTATICO') {
			return TipoIniciacao.QRCODE_ESTATICO;
		}
		if (this.selectedPixPaymentFavoredView.tipoQrCode === 'DINAMICO') {
			return TipoIniciacao.QRCODE_DINAMICO;
		}
		if (this.selectedPixPaymentFavoredView.tipoChave === PixKeyType.MANUAL) {
			return TipoIniciacao.NAO_INFORMADO;
		}

		return TipoIniciacao.CHAVE_PIX;
	}

	getDateToTransfer(modelDate: Date): string {
		if (moment(modelDate).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD')) {
			return null;
		} else {
			return moment(modelDate).format('YYYY-MM-DD');
		}
	}

	convertToPixPaymentFavored() {
		const model = new PixPaymentFavored();
		model.codigoFimAFim = this.selectedPixPaymentFavoredView.codigoFimAFim;

		model.chave = new PixKey();
		model.chave.codigo = this.selectedPixPaymentFavoredView.codigo;
		model.chave.tipoChave = this.selectedPixPaymentFavoredView.tipoChave;

		model.conta = new PixPaymentFavoredAccount();
		model.conta.numeroConta = this.selectedPixPaymentFavoredView.numeroConta;
		model.conta.tipoConta = this.selectedPixPaymentFavoredView.tipoConta;
		model.conta.numeroAgencia = this.selectedPixPaymentFavoredView.numeroAgencia;
		model.conta.documento = this.selectedPixPaymentFavoredView.documento;
		model.conta.iSPBCodigo = this.selectedPixPaymentFavoredView.iSPBCodigo;
		model.conta.iSPBNome = this.selectedPixPaymentFavoredView.iSPBNome;
		model.conta.nome = this.selectedPixPaymentFavoredView.nome;

		return model;
	}

	openModal(title: string, topText: string, text: string, btnName = 'Fechar', btnBackName = '') {
		const dialogRef = this.dialog.open(SharedModalInfoComponent, {
			width: '420px',
			data: {
				title: title,
				topText: topText,
				text: text,
				btnName: btnName,
				btnBackName: btnBackName
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			this.router.navigate(['pix']);
		});
	}

	handleError(error): void{
		if(error.status === 422 && error.error.CodigoErro == "ANTI_FRAUDE_VALIDATION"){
			this.openModalError();
			return;
		}

		AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem })

	};

	openModalError()  {
		const dialogRef= this.dialog.open(PixAntiFraudModalComponent, {
			width: '400px',
		});

		dialogRef.afterClosed().subscribe(() => {
			this.router.navigate(['pix']);
		});
	}

	goBack = () => this.router.navigate(['pix/pagamento']);
	onSetSignatureForm = (form: FormGroup) => this.form = form;
}






// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/payment-key/favored-create/assignature/assignature.component.ts